export async function fetchGetNewTokens(): Promise<any> {
	return (await fetch("https://data.fluxbeam.xyz/stats/tokens/new")).json();
}

export async function fetchToken(mint: string): Promise<any> {
	return (
		await fetch(`https://data.fluxbeam.xyz/tokens/${mint}`)
	).json();
}

export async function fetchTokenPriceChange(mint: string): Promise<any> {
	return (
		await fetch(`https://data.fluxbeam.xyz/tokens/${mint}/stats/change`)
	).json();
}

export async function fetchWalletHistoryTrades({
	mint,
	wallet,
	from,
	to,
}: any): Promise<any> {
	return (
		await fetch(
			`https://data.fluxbeam.xyz/tokens/${mint}/traders/${wallet}?from=${from}&to=${to}`
		)
	).json();
}

export async function fetchTokenPNL({ mint, wallet }: any): Promise<any> {
	return (
		await fetch(
			`https://data.fluxbeam.xyz/tokens/${mint}/traders/${wallet}/pnl`
		)
	).json();
}

export async function fetchTokenMetadata(mint: string): Promise<any> {
	return (await fetch(`https://api.degencdn.com/v1/tokens/${mint}`)).json();
}

export async function fetchTokenCandles({
	mint,
	interval,
	to,
	from,
	count
}: any): Promise<any> {
	const params = new URLSearchParams();
	params.set("interval", interval);
	params.set("count", count);

	if (to)
	params.set("to", to);

	if (from)
	params.set("from", from);

	return (
		await fetch(
			`https://data.fluxbeam.xyz/tokens/${mint}/candles?${params.toString()}`
		)
	).json();
}

export async function fetchTokenEvents({
	mint,
	to,
	from,
}: any): Promise<any> {
	const params = new URLSearchParams();

	if (to)
	params.set("to", to);

	if (from)
	params.set("from", from);

	return (
		await fetch(
			`https://data.fluxbeam.xyz/tokens/${mint}/events?${params.toString()}`
		)
	).json();
}
